// extracted by mini-css-extract-plugin
export default {"header":"StationInfo_header__qKePC","linkButton":"StationInfo_linkButton__0lTyR","link":"StationInfo_link__2bk4U"};